import { SalaryFiltersParams } from '@/modules/salary/types'
import { SalaryFilterParam } from '../constants'
import {
  SALARY_FULL_TIME_VALUE,
  SALARY_LOCUM_TENENS_VALUE,
  SALARY_PART_TIME_VALUE,
  SALARY_PRN_VALUE,
} from '@/modules/surveys/configs/onboarding/current-job-pane-config'
import { PHYSICIAN_SLUG } from '@/modules/surveys/configs/onboarding/personal-info-config'
import { MainRoutes } from '@/utils/routes'

export const SPLIT_SALARY_INDEX_OFFSET = 2
export const SALARY_PATH = 'salary'
export const STATE_PATH_INDEX = 3
export const SALARY_PATH_INDEX = 2
export const PROFESSION_OR_OCCUPATION_PATH_INDEX = 1
export const JOB_TYPE_PATH_INDEX = 0

function getJobType(jobType: string | null | undefined) {
  if (!jobType) {
    return SALARY_FULL_TIME_VALUE
  }
  if (jobType.includes('locum')) {
    return SALARY_LOCUM_TENENS_VALUE
  }
  if (jobType.includes('prn')) {
    return SALARY_PRN_VALUE
  }
  if (jobType.startsWith('partTime') || jobType.startsWith('part-time')) {
    return SALARY_PART_TIME_VALUE
  }
  return SALARY_FULL_TIME_VALUE
}

// NOTE: when navigating to a new salary page,
// you will also need to update the filters calling
// const { updateSalaryFilters } = useSalaryFilters({
//   isAuthenticated,
// })
export function getSalaryUrl({
  filtersParams,
  defaultUserProfessionSlug = PHYSICIAN_SLUG,
  isTrendsPage = false,
}: {
  filtersParams: Partial<SalaryFiltersParams>
  defaultUserProfessionSlug?: string
  isTrendsPage?: boolean
}) {
  const filterKeysToInclude = [
    SalaryFilterParam.page,
    SalaryFilterParam.sortBy,
    SalaryFilterParam.payPeriod,
    SalaryFilterParam.salaryId,
  ]

  // cannot use lodash since this is used in middleware
  const filtersToPush = Object.fromEntries(
    Object.entries(filtersParams).filter(([key, value]) => {
      return (
        filterKeysToInclude.includes(key as SalaryFilterParam) &&
        value !== undefined &&
        value !== null &&
        value !== ''
      )
    }),
  ) as Record<string, string>

  const searchParams = new URLSearchParams(filtersToPush)
  const jobType = getJobType(filtersParams[SalaryFilterParam.jobType])
  const location = filtersParams[SalaryFilterParam.location]?.toLowerCase?.()
  const occupation = filtersParams[SalaryFilterParam.occupation]
  const professionOrOccupation = occupation || defaultUserProfessionSlug

  let newUrl = `${MainRoutes.Salary}/${jobType}/${professionOrOccupation}/${SALARY_PATH}`
  newUrl = location ? `${newUrl}/${location}` : newUrl
  newUrl = isTrendsPage ? `${newUrl}/trends` : newUrl
  return `${newUrl}${searchParams.size ? `?${searchParams.toString()}` : ''}`
}
